<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    </div>
    <router-view/>
  </div>
</template>

<script type="text/javascript">
  import { eventListeners } from './mixins/eventListeners.js';

  export default {
    name: 'App',
    mixins: [eventListeners],
    components: {
      
    },
    watch: {

    },
    computed: {
        
    },
    mounted: function () {
        this.hookEvents();
    },
    data () {
        return {
            
        };
    }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
